import React, { useState, useEffect } from "react";
// import "../css/Blog.css";
import NAV from "./nav";
import Carousel from "./carousel";
import {fetchBlog} from "../api";
import PriceScroller from "../components/pricescroll";

const About = () => {

  return (
    <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="about"/>
            {/*<!-- Header Start -->*/}
            <div class="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>
                    <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Orion Analytics</h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        </div>
            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}
    <div style={styles.container}>
        <h1 style={styles.heading}>About Orionics</h1>
        <p style={styles.paragraph}>
        <strong>Orion Analytics</strong> helps Indian investors navigate capital
        markets with data-driven analytics. We’re here to simplify finance and
        empower decision-makers with actionable insights across equity, derivatives,
        and macroeconomic trends.
      </p>
    </div>

    </div>
  );
};

const styles = {
  container: {
    maxWidth: "48rem", // max-w-3xl
    margin: "0 auto", // mx-auto
    padding: "2.5rem 1.5rem", // py-10 px-6
    color: "#1F2937", // text-gray-800
  },
  heading: {
    fontSize: "1.5rem", // text-2xl
    fontWeight: "700", // font-bold
    marginBottom: "1rem", // mb-4
  },
  paragraph: {
    fontSize: "1rem", // text-base
    lineHeight: "1.75rem", // for better readability
  },
};

export default About;
